// extracted by mini-css-extract-plugin
module.exports = {"periodDate":"PeriodDateRenderer_periodDate__1my9i"};